module.exports = __webpack_public_path__ + "static/media/furia-ecommerce.f824742c.svg";